import React from 'react'

import { cn } from '@/lib/utils'

type ColorCirclesProps = {
  colors: string[]
  className?: string
}

export const ColorCircles = ({ colors, className }: ColorCirclesProps) => {
  // Ensure count is within the valid range
  const limitedColors = colors.slice(0, 5)

  return (
    <div className={cn('flex items-center justify-center', className)}>
      <div
        className="relative"
        style={{ width: `${limitedColors.length * 6 + 2}px`, height: '12px' }}
      >
        {limitedColors.map((color, index) => (
          <div
            key={index}
            className="absolute size-[12px] rounded-full border border-white"
            style={{
              top: 0,
              left: `${index * 6}px`,
              backgroundColor: color ? color : 'black',
            }} // Adjust the overlap by changing the left value
          />
        ))}
      </div>
    </div>
  )
}
